import { render, staticRenderFns } from "./ContactFeedMsg.vue?vue&type=template&id=3edd0f62&scoped=true&"
import script from "./ContactFeedMsg.vue?vue&type=script&lang=js&"
export * from "./ContactFeedMsg.vue?vue&type=script&lang=js&"
import style0 from "./ContactFeedMsg.vue?vue&type=style&index=0&id=3edd0f62&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3edd0f62",
  null
  
)

export default component.exports